import React, { useEffect } from "react";
import Navbar from "./NavBar";
import HeroSection from "./Herosection";
import { Layout } from "antd";
import FAQ from "./FAQ";
import Footer from "./Footer";
import PricingCards from "./Payment";
import Features from "./Features";
import loadGAScript from "./loadGAScript";
import VideoSection from "./VideoComponent";
import DashboardFeatures from "./DashboardFeatures";
import RecruitmentAgencies from "./RecruitmentAgencies";
import WhyChronoflow from "./WhyChronoflow";
import RecruitmentTransformation from "./RecruitmentTransformation";
import JobBoardSection from "./JobBoardSection";
import ModernCTASection from "./ModernCTASection";


const { Content } = Layout;

const LandingPage = () => {
  useEffect(() => {
    loadGAScript(process.env.REACT_APP_GOOGLE_TRACKING_ID);
  }, []);

  return (
    <div className="landing-page-content">
      <Layout className="layout">
        <Navbar />
        <Content>
          <div className="hero-wrapper">
            <HeroSection />
          </div>
          <div className="sections-wrapper">
            <VideoSection videoId="aVmh1rvaJIY"/>
            <RecruitmentTransformation/>
            <WhyChronoflow/>
            <JobBoardSection/>
            <DashboardFeatures/>
            <PricingCards />
            <ModernCTASection />
            <RecruitmentAgencies/>
            <FAQ />
          </div>
        </Content>
        <Footer />
      </Layout>
    </div>
  );
};

export default LandingPage;
